import { useQuery } from '@tanstack/react-query';

import getPresences from 'Api/host-attendance-record/getPresences';

import { useUserInfo } from 'Store/userInfo';
import getPresencesResponse from 'Domain/host-attendance-record/model/response/getPresencesResponse';

const useGetPresences = ({ isPublic = false } = {}) => {
  const { userId } = useUserInfo();

  return useQuery({
    queryKey: ['presences', userId],
    queryFn: async () => {
      const response = await getPresences();

      const result = getPresencesResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !isPublic,
    gcTime: 0,
  });
};

export default useGetPresences;
